import { ScoreContext, IProps } from "./context";
import React from "react";
interface ScoreProviderProps {
    type: IProps;
    children: React.ReactNode;
}
export default function ScoreProvider({ type, children }: ScoreProviderProps) {
    return (
        <ScoreContext.Provider value={type}>{children}</ScoreContext.Provider>
    );
}
